import React from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  IonText,
  IonToolbar,
  useIonAlert,
} from "@ionic/react";
import AppHeader from "components/Header/AppHeader";

import { loadQuiz } from "services/quiz";
import { submitScores } from "services/teams";
import Spacer from "components/spacer";
//import { submitTeamResults } from "services/teams";

interface props {
  loadQuiz: Function;
  submitScores: Function;
  teams: any;
  quizConfig: any;
  scoresSubmitted: Boolean;
}

type RouteParams = {
  roundId: string;
};

const ScoringRound: React.FC<props> = ({
  loadQuiz,
  submitScores,
  teams,
  quizConfig,
  scoresSubmitted,
}) => {
  const [presentAlert] = useIonAlert();
  const history = useHistory();

  let { roundId } = useParams<RouteParams>();

  const selectTeam = (team: number) => {
    history.push(`/scoring/${roundId}/team/${team}`);
  };

  const teamResultsSubmitted = (answers: any) => {
    return answers !== null && answers !== undefined;
  };

  const teamResultsCount = (answers: any) => {
    if (typeof answers === "object") {
      return answers?.reduce((a: number, b: number) => a + b, 0);
    } else return 0;
  };

  const teamCWResultsSubmitted = (answers: any) => {
    return answers[0] !== null && answers[0] !== undefined;
  };

  const teamCWResultsCount = (answers: any) => {
    if (answers) return answers?.reduce((a: number, b: number) => a + b, 0);
    else return 0;
  };

  const getRoundName = () => {
    if (parseInt(roundId) === quizConfig.format.rounds) return "Crossword";
    return "R" + (parseInt(roundId) + 1);
  };

  const submitResults = () => {
    // console.log("submitting results");
    submitScores();
    // loadQuiz();
    /* using this function when returning to the quiz will cause the CC to jump back to the
    first page because we send an ad page progress to the CC which it can't handle. */
    history.push("/quiz");
  };

  const returnToQuiz = () => {
    // loadQuiz();
    /* using this function when returning to the quiz will cause the CC to jump back to the
    first page because we send an ad page progress to the CC which it can't handle. */
    history.push("/quiz");
  };

  const onClickReturn = () => {
    if (scoresSubmitted) {
      returnToQuiz();
    } else {
      presentAlert({
        header: "Alert",
        subHeader: "Unsubmitted scores",
        message:
          "You have not submitted the scores since you last changed them.<br/><br/>Are you sure you want to continue?",
        buttons: [
          {
            text: "Continue",
            role: "confirm",
            handler: returnToQuiz,
          },
          {
            text: "Return",
            role: "cancel",
          },
          // {
          //   text: "Submit",
          //   handler: submitResults,
          // },
        ],
      });
    }
  };

  return (
    <>
      <AppHeader title={`Scoring: ${getRoundName()}`} />
      <IonContent fullscreen className="ion-padding dashboard">
        <div className="container">
          <h2>Select Team</h2>
          <IonCard>
            <IonCardContent>
              {teams.teams.length > 0 ? (
                <>
                  {roundId < quizConfig.format.rounds ? (
                    <IonList>
                      {teams.teams.map((team: any, i: number) => (
                        <IonItem
                          key={i}
                          button
                          onClick={() => selectTeam(team.teamId)}
                          detail={true}
                          color={
                            teamResultsSubmitted(team.rounds[roundId])
                              ? "success"
                              : ""
                          }
                        >
                          <IonLabel>{team.teamName}</IonLabel>
                          <IonLabel>
                            Score: {teamResultsCount(team.rounds[roundId])}
                          </IonLabel>
                        </IonItem>
                      ))}
                    </IonList>
                  ) : (
                    <IonList>
                      {teams.teams.map((team: any, i: number) => (
                        <IonItem
                          key={i}
                          button
                          onClick={() => selectTeam(team.teamId)}
                          detail={true}
                          color={
                            teamCWResultsSubmitted(team.puzzle) ? "success" : ""
                          }
                        >
                          <IonLabel>{team.teamName}</IonLabel>
                          <IonLabel>
                            Score: {teamCWResultsCount(team.puzzle)}
                          </IonLabel>
                        </IonItem>
                      ))}
                    </IonList>
                  )}
                </>
              ) : (
                <>
                  <IonText>
                    <p>No teams are currently registered for this event</p>
                  </IonText>
                  <IonButton onClick={() => history.push("/teams")}>
                    Register Teams
                  </IonButton>
                </>
              )}
              {quizConfig.format.isCrossword && (
                <>
                  {parseInt(roundId) === quizConfig.format.rounds - 1 && (
                    <IonButton
                      onClick={() =>
                        history.push("/scoring/" + quizConfig.format.rounds)
                      }
                      color="warning"
                    >
                      Enter Crossword Results
                    </IonButton>
                  )}
                  {parseInt(roundId) === quizConfig.format.rounds && (
                    <IonButton
                      onClick={() =>
                        history.push(
                          "/scoring/" + (quizConfig.format.rounds - 1)
                        )
                      }
                      color="warning"
                    >
                      Round {quizConfig.format.rounds} Results
                    </IonButton>
                  )}
                </>
              )}
            </IonCardContent>
            <IonToolbar>
              <IonItem lines="none">
                <IonButton
                  color="secondary"
                  size="default"
                  onClick={onClickReturn}
                >
                  Return To Quiz
                </IonButton>
                <IonButton
                  color="primary"
                  fill="solid"
                  size="default"
                  onClick={submitResults}
                >
                  Submit
                </IonButton>
              </IonItem>
              <Spacer size="30" />
            </IonToolbar>
          </IonCard>
        </div>
      </IonContent>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  teams: state.teams,
  quizConfig: state.quiz.quizConfig,
  scoresSubmitted: state.teams.scoresSubmitted,
});

export default connect(mapStateToProps, { loadQuiz, submitScores })(
  ScoringRound
);
